import { render, staticRenderFns } from "./listBanners.vue?vue&type=template&id=78807749&scoped=true&"
import script from "./listBanners.vue?vue&type=script&lang=js&"
export * from "./listBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78807749",
  null
  
)

export default component.exports